<template>
  <div id="tranAm">
    <!--    <div class="bg-color-black">-->
    <div class="d-flex pt-2 pl-2" style="justify-content: space-between;align-items: center;">
         <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">成果转化平台名录</span>
        </span>
      <span @click="dialogVisible = true" style="font-size: 0.2rem;color: #ffffff;cursor: pointer;">更多+</span>
      <el-dialog title="成果转化平台名录" :visible.sync="dialogVisible" width="80%" center>
        <el-table :data="dataList" style="width: 95%;margin: 0 auto;" :header-cell-style="{background:'#043B95',color:'#fff','text-align':'center',}"
                  :row-style="{background:'#043B95',color:'#fff'}">
          <el-table-column label="序号" :index="indexMethod" type="index" width="60px" align="center">
<!--            <template slot-scope="scope">-->
<!--              <span>{{ scope.$index + 1 }}</span>-->
<!--            </template>-->
          </el-table-column>
          <el-table-column prop="platformName" label="平台名称" align="center">
          </el-table-column>
          <el-table-column label='建设单位名称' prop='companyName' align="center">
            <!--              <template slot-scope="scope">-->
            <!--                {{ scope.row.carrierTypeDisplay }}-->
            <!--              </template>-->
          </el-table-column>
          <el-table-column prop="establishTime" label="成立时间" width="180" align="center">
          </el-table-column>
          <!--            <el-table-column prop="industryList" label="技术领域" align="center">-->
          <!--              <template slot-scope="scope">-->
          <!--                {{ scope.row.industryList[0].industryName }}-->
          <!--              </template>-->
          <!--            </el-table-column>-->
<!--          <el-table-column label='操作' align="center">-->
<!--            <template slot-scope='scope'>-->
<!--              <a @click="getDetail(scope.row.id)" style="color: #5cd9e8;cursor: pointer;">详情</a>-->
<!--            </template>-->
<!--          </el-table-column>-->


        </el-table>
        <el-pagination background :total='total' :current-page.sync='searchForm.pageNum' :page-size='searchForm.pageSize' @current-change='pageChange' class='pagination'
                       layout='prev, pager, next'></el-pagination>
      </el-dialog>
    </div>
    <div class="d-flex jc-center body-box" style=" margin-top: 0.5rem;width:100%;height:90%;padding-bottom: 0.1rem">
      <!--        <dv-scroll-board :config="config" style="width:100%;height: 3rem" />-->
      <dv-scroll-board :config="config" @click="row" style="width:100%;height:100%" />
    </div>
  </div>
  <!--  </div>-->
</template>
<!-- import JavaScript -->

<script>
import sciApi from '@/api/index.js'
// import $ from 'jquery'
export default {
  data() {
    return {
      dialogVisible: false,
      dialogFormVisible: false,
      videoUrl:'',
      dataList:[],
      total: 0,
      searchForm: {
        pageSize:10,
        platform:'3',
        townStreet:'',
        pageNum:1
      },
      detail: {},
      tum:[],
      config: {
        header: ['<span style="font-weight: bold">平台名称</span>', '<span style="font-weight: bold">单位名称</span>'],
        data: [
          // ['重庆市石鱼小企业创业基地','众创空间'],
          // ['重庆(铜梁)万洋众创城','众创空间'],
          // ['微企创业园','众创空间'],
          // ['传媒创业园','众创空间'],
          // ['铜梁高新区铜生科技众创空间','众创空间'],
          // ['铜生科技众创空间','众创空间'],
          // ['铜梁高新区科技企业孵化器','孵化器'],
        ],
        headerHeight:50,
        rowNum:5,
        headerBGC:'rgba(51, 109, 233, 0.5)',
        evenRowBGC:'rgba(51, 109, 233, 0)',
        oddRowBGC:'rgba(51, 109, 233, 0.2)',
        align: ['center','center'],
        columnWidth: [240,200],
      },

    };
  },
  watch:{
    // setregion: {
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     this.searchForm.townStreet = val
    //     this.init()
    //   }
    // },
  },
  computed: {
    setregion() {
      // console.log(this.$store.state.region)
      return this.$store.state.region
    },
    indexMethod() {
      return (this.searchForm.pageNum - 1) * (this.searchForm.pageSize) + 1
    }
  },
  created() {
  },
  mounted() {
    this.init().then(()=>{
      this.config ={   header: ['<span style="font-weight: bold">平台名称</span>', '<span style="font-weight: bold">单位名称</span>'],
        // data:this.tum,
        data:this.tum,
        headerHeight:50,
        rowNum:5,
        headerBGC:'rgba(51, 109, 233, 0.5)',
        evenRowBGC:'rgba(51, 109, 233, 0)',
        oddRowBGC:'rgba(51, 109, 233, 0.2)',
        align: ['center','center'],
        columnWidth: [240,200],
      }
    })
  },
  methods: {
    async init() {
      await sciApi.selectCarrierList(
          this.searchForm
      ).then((data) => {
        this.dataList = data.list || []
        this.total=data.total
        this.dataList.forEach((item) => {
          let num = []
          num.push(item.platformName)
          num.push(item.companyName || '-')
          num.push('<span style="display:none">'+ item.id + '</span>')
          // num.push(item.totalPrices)
          this.tum.push(num)

        })


      })
    },
    pageChange() {
      this.init();
    },
    row(val){
      console.log(val,'val')
      var id=val.row[2].replace(/[^0-9]/ig,"")
      this.getDetail(id);
    },
    goto() {
      this.dialogVisible = true
      this.dialogFormVisible = false
    },
    async getDetail(id) {
      this.detail = []
      await sciApi.carrierDetail({
        id: id
      }).then((data) => {
        this.detail = data
        this.dialogVisible = false
        this.dialogFormVisible = true
      })
    }
  }
};
</script>

<style lang="scss">
.el-table--border::after {

  width: 0px;
}
.gutter{
  display:block !important;
}
.el-table__header-wrapper{
  background:none;
}
.el-pagination{
  margin-top: 30px;
  text-align: center;
}
// .el-pagination.is-background .el-pager li:not(.disabled).active {
// background-color: rgba(4,59,149,0.8);
// }
.Sta_table_one1 tbody tr td:nth-child(2n-1) {
  background: rgba(4,59,149,0.8);
  color: #3FCAFA;
  vertical-align: middle;
}
.Sta_table_one1 tbody tr td {
  background: rgba(4,59,149,0.8);
  border: 1px solid rgba(38,111,232,0.5);
  padding: 10px;
  font-size: 16px;
  line-height: 24px;
}
#tranAm {
  padding: 0.2rem;
  width: 100%;
  height: 100%;

  //border-radius: 0.0625rem;
  .bg-color-black {
    padding: 0.0625rem;
    height: 4.5rem;
    border-radius: 0.125rem;
  }

  .text {
    color: #c3cbde;
  }

  .body-box {
    //border-radius: 0.125rem;
    overflow: hidden;
  }

  .head {
    background: rgba(255, 255, 255, 0.1);
    font-size: 18px;
    padding: 0.2rem;
    color: #68d8fe;
    display: flex;
    justify-content: space-between;
    line-height: 1.05;
  }

  .slideBox ul li {
    line-height: 36px;
    height: 36px;
    font-size: 16px;
    color: #4c9bfd;
    //padding: 0 0.2rem;
  }

  .slideBox ul li a {
    color: #4c9bfd !important;
    line-height: 40px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    width: 33%;
    text-align: left;
    float: left;
  }

  .slideBox ul li p {
    text-align: center;
    color: #4c9bfd !important;
    line-height: 40px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    width: 33%;
    float: left;
  }

  .slideBox ul li span {
    float: right;
    line-height: 40px;
    padding-right: 0.1rem;
  }
}

.el-dialog {
  background: rgba(51, 109, 233, 0.5) !important;
  color: #fff !important;
}

.el-dialog__title,
.el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
  font-size: 0.25rem !important;
}

.el-table__body tr.current-row>td {
  background: #3FCAFA !important;
}

.el-table td,
.el-table th.is-leaf,
.el-table td,
.building-top .el-table th.is-leaf {
  border-bottom: 1px solid rgba(38, 111, 232, 0.5);
  // border-right: 1px solid #5cd9e8!important;
}

.el-table::before {
  border-color: rgba(38, 111, 232, 0.5);
  display: none !important;
}

// .el-table--border  td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {

// }
.el-table__body tr.current-row>td,
.el-table--enable-row-hover .el-table__body tr:hover>td {
  background: none !important;
}
</style>